import React from 'react'
import InfoBanner from '../InfoBanner'

/**
 * Componente para mostrar la new Brand Equity (Contenido estático)
 *
 * @component
 *
 */

export const InteligenciaArtificial = (props) => {
  const [width, setWidth] = React.useState(window.innerWidth)
  const breakpoint = 620

  React.useEffect(() => {
    const saveWidth = () => {
      setWidth(window.innerWidth)
    }

    /* Inside of a "useEffect" hook add an event listener that updates
        the "width" state variable when the window size changes */
    window.addEventListener('resize', saveWidth)

    /* passing an empty array as the dependencies of the effect will cause this
        effect to only run when the component mounts, and not each time it updates.
        We only want the listener to be added once */
    return () => window.removeEventListener('resize', saveWidth)
  }, [])

  const url = window.location.href

  return (
    <section id="news-detail" className="text-center">
      <div className="col-md-8 col-md-offset-2 section-title">
        <h2>
          <span className="title">News</span>
        </h2>
      </div>
      <InfoBanner
        section={'Inteligencia Artificial'}
        tittle={'La IA en marketing: Potenciar, no reemplazar, la visión humana'}
        readingTime={'Tiempo de lectura 4 minutos'}
        keywords={['Inteligencia artificial', 'Marketing']}
        urlDesktop={'/img/news/InteligenciaArtificial/ia1.webp'}
        urlMobile={'/img/news/InteligenciaArtificial/ia1-mob.webp'}
      />
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                <b>La inteligencia artificial como motor de estrategias personalizadas</b>
                <br></br>
                <br></br>
                En un entorno de marketing cada vez más competitivo, donde la rapidez y la precisión son esenciales, 
                la inteligencia artificial (IA) se ha convertido en una herramienta indispensable. 
                Su capacidad para procesar grandes volúmenes de datos en tiempo real permite a las marcas alcanzar 
                niveles de personalización que habrían sido inimaginables hace una década. Sin embargo, 
                este avance tecnológico no elimina la importancia del juicio y la creatividad humanas, elementos 
                clave para conectar auténticamente con los consumidores.   
                <br></br>
                <br></br>
              </p>
            </div>
          </div>
        </div>
      </article>
      <div
        className={width < breakpoint ? '' : 'container-fluid padding-fluid'}
      >
        <div className={width < breakpoint ? '' : 'row'}>
          <div className={width < breakpoint ? '' : 'col-md-12'}>
            <div className={width < breakpoint ? '' : 'col-md-8 col-md-offset-2'}>
              <div className="imgWithText">
                <img
                  style={{ width: '100%' }}
                  className="img-responsive"
                  alt="Recesion"
                  src="/img/news/InteligenciaArtificial/ia2.webp"
                ></img>
                <h2 className="img3Text">
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2">
              <p>
                <b>La personalización como ventaja competitiva</b>
                <br></br>
                <br></br>
                La IA ha transformado la interacción entre las marcas y sus audiencias, permitiendo 
                experiencias hiperpersonalizadas basadas en el análisis de datos de comportamiento, 
                preferencias y patrones de consumo. Estas capacidades no solo mejoran la efectividad 
                de las campañas publicitarias, sino que también optimizan la asignación de recursos, 
                un aspecto crucial en tiempos de incertidumbre económica. 
                <br></br>
                <br></br>
                Con esta tecnología, las empresas pueden comprender mejor a su público objetivo y diseñar 
                estrategias que fortalezcan la lealtad de los clientes, al mismo tiempo que maximizan el 
                retorno de inversión. Sin embargo, la clave está en utilizar la IA como una herramienta 
                complementaria que facilite la toma de decisiones, no como un reemplazo del criterio humano.   
                <br></br>
                <br></br>
              </p>
            </div>
          </div>
        </div>
      </article>
      <div
        className={width < breakpoint ? '' : 'container-fluid padding-fluid'}
      >
        <div className={width < breakpoint ? '' : 'row'}>
          <div className={width < breakpoint ? '' : 'col-md-12'}>
            <div className={width < breakpoint ? '' : 'col-md-8 col-md-offset-2 text-center'}>
              <div className="imgWithText">
                <img
                  style={{ width: '100%' }}
                  className="img-responsive"
                  alt="InteligenciaArtificial"
                  src="/img/news/InteligenciaArtificial/ia3.webp"
                ></img>
                <h2 className="img3Text">
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                <b>La esencia humana como elemento diferenciador</b>
                <br></br>
                <br></br>
                A pesar de los avances que ofrece la IA, las marcas no deben perder de vista que su éxito depende 
                de su capacidad para generar relaciones auténticas con los consumidores. Una marca no es solo un 
                conjunto de datos o métricas; es una personalidad que se construye y evoluciona a través de interacciones humanas. 
                <br></br>
                <br></br>
                El equilibrio entre la automatización y la humanización resulta esencial para construir confianza y 
                fomentar la fidelidad del cliente. Las herramientas de IA pueden procesar y analizar información, 
                pero la creatividad y los insights emocionales necesarios para una estrategia auténtica siguen siendo 
                un terreno exclusivamente humano.   
                <br></br>
                <br></br>
              </p>
            </div>
          </div>
        </div>
      </article>
      <div
        className={width < breakpoint ? '' : 'container-fluid padding-fluid'}
      >
        <div className={width < breakpoint ? '' : 'row'}>
          <div className={width < breakpoint ? '' : 'col-md-12'}>
            <div className={width < breakpoint ? '' : 'col-md-8 col-md-offset-2 text-center'}>
              <div className="imgWithText">
                <img
                  style={{ width: '100%' }}
                  className="img-responsive"
                  alt="InteligenciaArtificial"
                  src="/img/news/InteligenciaArtificial/ia4.webp"
                ></img>
                <h2 className="img3Text">
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                <b>Un catalizador para la creatividad, no un sustituto</b>
                <br></br>
                <br></br>
                Aunque la IA mejora la eficiencia al identificar tendencias, analizar datos masivos y sugerir acciones, 
                no puede replicar la intuición ni el juicio necesarios para desarrollar campañas de marketing efectivas. 
                Las decisiones estratégicas requieren de la experiencia y el entendimiento de las dinámicas humanas que 
                solo los profesionales del marketing pueden aportar.
                <br></br>
                <br></br>
                Por ello, la IA debe entenderse como un catalizador que amplifica las capacidades humanas, permitiendo 
                que los expertos en marketing dediquen más tiempo a la creatividad y a la innovación.    
                <br></br>
                <br></br>
              </p>
            </div>
          </div>
        </div>
      </article>
      <div
        className={width < breakpoint ? '' : 'container-fluid padding-fluid'}
      >
        <div className={width < breakpoint ? '' : 'row'}>
          <div className={width < breakpoint ? '' : 'col-md-12'}>
            <div className={width < breakpoint ? '' : 'col-md-8 col-md-offset-2 text-center'}>
              <div className="imgWithText">
                <img
                  style={{ width: '100%' }}
                  className="img-responsive"
                  alt="InteligenciaArtificial"
                  src="/img/news/InteligenciaArtificial/ia5.webp"
                ></img>
                <h2 className="img3Text">
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                <b>El futuro del marketing: un enfoque híbrido</b>
                <br></br>
                <br></br>
                La combinación de tecnología avanzada y creatividad humana será fundamental para el marketing del 
                futuro. La IA, cuando se utiliza correctamente, potencia la capacidad de las marcas para entender 
                y conectar con sus audiencias de manera más significativa. Sin embargo, su verdadero impacto radica 
                en complementar, no reemplazar, la intuición y la experiencia humana.   
                <br></br>
                <br></br>
                El éxito de una marca dependerá de su habilidad para equilibrar tecnología y humanización, 
                generando conexiones emocionales genuinas con su público. En última instancia, los insights más 
                valiosos son aquellos que surgen de la interacción entre la inteligencia artificial y el ingenio 
                humano.     
                <br></br>
                <br></br>
              </p>
            </div>
          </div>
        </div>
      </article>

      <div className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-1 text-left"></div>
            <div
              className="col-md-3 text-left"
              style={{ display: width < breakpoint ? 'block' : 'none' }}
            >
              <p className="titleShare">COMPARTE</p>
              <div style={{ paddingBottom: '7px' }}>
                <a
                  className="share"
                  href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </div>
              <div style={{ paddingBottom: '7px' }}>
                <a
                  className="share"
                  href={`https://twitter.com/intent/tweet?url=${url}&text=Recesión`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Twitter
                </a>
              </div>
              <div style={{ paddingBottom: '7px' }}>
                <a
                  className="share"
                  href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </div>
              <div style={{ paddingBottom: '7px' }}>
                <a
                  className="share"
                  href={`mailto:?subject=Quiero compartir contigo esta noticia&body=Mira esta noticia ${url}`}
                >
                  Email
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
